<template><div class="main flex">
  <sticky-bar @back="$router.push('/s')" :loading="!user">My Account</sticky-bar>
  <div class="flex-fill padded scroll">
    <template v-if="!user">
      Loading ...
    </template>
    <template v-else>
      <table>
      <tr>
        <th>Email:</th>
        <td class="email" v-html="user.email" />
      </tr>
      <tr>
        <th>Name:</th>
        <td>
          {{ user.firstName || '-' }}
          {{ user.lastName || '-' }}
          <button @click="editingName=true">Edit</button>
        </td>
      </tr>
      <tr>
        <th>Password:</th>
        <td><button @click="$router.push('/password-reset')">Reset Password</button></td>
      </tr>
      </table>
      <template v-if="!$store.state.permissions || accounts === null">
        Loading ...
      </template>
      <template v-else-if="accounts === false">
        An error occurred. <button @click="loadAccounts">Try Again</button>
      </template>
      <template v-else>
        <p>
          <b>Access and Notifications</b>
          <table class="access">
          <tr>
            <th>Owner</th>
            <th>Fleet</th>
            <th>VPN</th>
            <th>Manager</th>
            <th>Restricted</th>
            <th>Notifications</th>
            <th />
          </tr>
          <tr v-for="(f,i) of $store.state.permissions.fleets"
              :key="`r-${i}`">
            <td>{{ ((f.account_id in accounts) && accounts[f.account_id].owner) && accounts[f.account_id].owner.email || '-' }}</td>
            <td>{{ f.name }}</td>
            <td v-if="f.unconfirmed" colspan="3">
              Invited
              <button @click="acceptInvitation(f.id)">Accept</button>
            </td>
            <template v-else>
              <td><span v-if="f.vpn" class="material-icons">check</span></td>
              <td><span v-if="f.managed" class="material-icons">check</span></td>
              <td><span v-if="f.restricted" class="material-icons">check</span></td>
              <td @click="toggleSubscriber(f)"><span class="material-icons">
                {{ f.subscriber ? 'check_box' : 'check_box_outline_blank' }}
              </span></td>
            </template>
            <td @click="tentativeDeleteFleet=f"><span class="material-icons">delete</span></td>
          </tr>
          </table>
        </p>
      </template>
    </template>
    <modal-dialog v-if="editingName" :strong="true" @close="editingName=false">
      <div class="error" v-if="error">An error occurred. Please try again.</div>
      <table>
      <tr>
        <th>First Name:</th>
        <td><input v-model="firstName" /></td>
      </tr>
      <tr>
        <th>Last Name:</th>
        <td><input v-model="lastName" /></td>
      </tr>
      <tr>
        <th />
        <td>
          <button @click="acceptName">Save</button>
          &nbsp;
          <button @click="editingName=false">Cancel</button>
        </td>
      </tr>
      </table>
    </modal-dialog>
    <modal-dialog v-if="tentativeDeleteFleet !== null" @close="tentativeDeleteFleet = null">
      <b>Are you sure</b> you want to delete your own access to fleet <b v-html="tentativeDeleteFleet.name"></b>?
      <p>This action will <b>permanently</b> revoke your access.</p>
      <button @click="deleteAccess(tentativeDeleteFleet.id)">Delete</button>
      &nbsp;
      <button @click="tentativeDeleteFleet = null">Cancel</button>
    </modal-dialog>
  </div>
</div></template>
<script>
import ModalDialog from '../ModalDialog'
import StickyBar from '../StickyBar'
import { mapActions, mapState } from 'vuex'
export default {
  name: 'my-account',
  components: { ModalDialog, StickyBar },
  data() {
    return {
      editingName: false,
      firstName: '',
      lastName: '',
      error: false,
      accounts: false,
      tentativeDeleteFleet: null,
    }
  },
  computed: {
    ...mapState(['user']),
  },
  created() {
    this.loadAccounts()
  },
  watch: {
    editingName(nv) {
      this.error = false
      if (nv) {
        this.firstName = this.user.firstName
        this.lastName = this.user.lastName
      }
    },
  },
  methods: {
    async acceptName() {
      try {
        await this.$store.dispatch('changeUserNames', { firstName: this.firstName, lastName: this.lastName })
        this.editingName = false
      } catch(e) {
        console.error(e)
        this.error = true
      }
    },
    async loadAccounts() {
      this.accounts = null
      try {
        let aa = await api.getAccounts(), dct = {}
        for (const a of aa)
          dct[a.id] = a
        this.accounts = dct
      } catch(e) {
        console.error(e)
        this.accounts = false
      }
    },
    async toggleSubscriber(f) {
      await this.setSubscriber({ fid: f.id, subscriber: !f.subscriber })
    },
    ...mapActions(['acceptInvitation','setSubscriber']),
    deleteAccess() {
      this.$store.dispatch('deleteAccess', this.tentativeDeleteFleet.id)
      this.tentativeDeleteFleet = null
    },
  },
}
</script>
<style lang="scss" scoped>
.access {
  border-collapse: collapse;
  margin-top: 5px;
  th, td {
    border: 1px solid #000;
    padding: 5px 10px;
    text-align: center;
  }
}
</style>
